import gql from "graphql-tag";

export const GET_FEEDBACK_BY_ID = gql`
query getFeedbackById($id: uuid!){
  Feedback(where: { id: {_eq: $id}}){
    id
    feedback 
    Customer { id name mobile email city profileImage label SalesExecutive{ id name profileImage } }
    Attachments {id path}
    created_at
  }
}`